import React from 'react'
import { useNavigate } from 'react-router'
import { useDispatch } from 'react-redux'
import {
  Box,
  Button,
  Typography,
  useTheme,
} from '@mui/material'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import { useHandleLogout } from 'components/Layout/Header/helpers'
import Logo from 'static/images/logo.svg'

const PendingApprovalPage = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const theme = useTheme()
  const handleLogout = useHandleLogout(dispatch, navigate)

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 3,
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Box
        component="img"
        src={Logo}
        alt="MyStethi"
        sx={{ height: 48, mb: 4 }}
      />
      <Box sx={{ textAlign: 'center', maxWidth: 480 }}>
        <HourglassEmptyIcon sx={{ fontSize: 64, color: 'warning.main', mb: 2 }} />
        <Typography variant='h4' fontWeight={700} gutterBottom>
          Account Under Review
        </Typography>
        <Typography variant='body1' color='text.secondary' sx={{ mb: 4 }}>
          We're reviewing your account and will email you once it's approved.
        </Typography>
        <Button
          variant='outlined'
          onClick={handleLogout}
        >
          Sign Out
        </Button>
      </Box>
    </Box>
  )
}

export default PendingApprovalPage
